import { jsx as e } from "react/jsx-runtime";
import { MAP_BACKGROUND_OPTIONS as s } from "./index.es684.js";
import { uniqueId as a } from "lodash/fp";
import { useTheme as l } from "./index.es190.js";
import { FlexContainer as f } from "./index.es584.js";
import { Button as c } from "./index.es15.js";
const T = "popover-template-basic-footer", C = ({
  actions: r,
  testId: i = T,
  backgroundColor: m = "white",
  ...o
}) => {
  const { spacings: t } = l();
  return /* @__PURE__ */ e(
    f,
    {
      gap: t.s,
      padding: t.lg,
      width: "100%",
      justifyContent: "flex-end",
      testId: i,
      ...o,
      style: { backgroundColor: s[m], ...o.style },
      children: r.map((n, p) => /* @__PURE__ */ e(c, { ...n, size: "small" }, a(p.toString())))
    }
  );
};
export {
  T as POPOVER_TEMPLATE_BASIC_FOOTER_TEST_ID,
  C as PopoverTemplateBasicFooter
};
//# sourceMappingURL=index.es686.js.map
